<template>
    <div class="file_form">
        <div class="file_wrapper">
            <div class="label_title">Include a file</div>
            <div class="file_upload_block">
                <div class="icon_wrapper">
                    <picture v-full-image-path:assets="'file_icon.svg'" />
                </div>
                <div class="text_center">
                    <label class="file_btn file_upload_button">
                        <input
                            :id="question.label"
                            ref="fileInput"
                            type="file"
                            style="width: 100%"
                            @change="changeFile"
                            @input="$emit('input', $event.target.value)"
                        />
                        <div v-if="filename">
                            <div>{{ $t('form.selectNew') }}</div>
                        </div>
                        <span v-else>
                            {{ $t('form.selectFile') }}
                        </span>
                    </label>
                    <div class="file_info">
                        {{ $t('form.upTo5Mb') }}
                    </div>
                </div>

                <div v-if="filename" class="upload_file_wrapper text_center">
                    <div class="file_row">
                        <div class="upload_file">
                            {{ $t('form.selected') }} :
                            <span class="file_name">
                                {{ filename }}
                            </span>

                            <button
                                class="btn_remove_file"
                                @click="removeFile"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        question: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            filename: ''
        };
    },

    methods: {
        changeFile() {
            if (!this.$refs.fileInput.files.length) {
                this.removeFile();

                return;
            }

            const [file] = this.$refs.fileInput.files;

            this.filename = file.name;

            this.$emit('input', file);
        },

        removeFile() {
            this.$emit('input', null);

            this.filename = '';
        }
    }
};
</script>
